// extracted by mini-css-extract-plugin
export default {"terminalRoot":"OfflineSalesTerminalLayout_terminalRoot__vRDeI"};